export const simulationSteps = [
	{ label: "Simulação" },
	{ label: "Envio ao Cliente" }
];